/* a.b.art attribution schema 1. Shared by the storefront and Customer Events pixel. */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.ABArtAttributionCore = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var CAMPAIGN = '202610_abart_design', WINDOW = 7 * 86400000;
  var formats = ['carousel','reel','carousel','carousel','reel','carousel','carousel','reel','photo','photo','reel','carousel'];
  function url(value) {
    try {
      var u = new URL(value);
      return /^https?:$/.test(u.protocol) && /^(www\.)?abart\.com$/.test(u.hostname) ? u : null;
    } catch (_) { return null; }
  }
  function creative(value, source, selection) {
    if (typeof value !== 'string') return null;
    var qa = value.indexOf('qa_') === 0, plain = qa ? value.slice(3) : value;
    if (!selection && source === 'instagram' && plain === 'bio')
      return {source:source,campaign:CAMPAIGN,content:null,creative:'bio',placement:'ig_bio',qa:qa};
    var m = /^(fb|ig)_p(0[1-9]|1[0-2])_(carousel|reel|photo|story)$/.exec(plain);
    if (!m || (source === 'facebook' ? 'fb' : 'ig') !== m[1]) return null;
    var format = formats[Number(m[2])-1];
    if (selection ? m[1] !== 'ig' || m[3] !== format : (m[1] === 'fb' ? m[3] !== format : m[3] !== 'story')) return null;
    return {source:source,campaign:CAMPAIGN,content:'p'+m[2],creative:plain,
      placement:selection?'ig_bio_selection':m[1]==='fb'?'fb_direct':'ig_story',qa:qa};
  }
  function parseEntry(value) {
    var u = url(value); if (!u) return null;
    var p = u.searchParams, source = p.get('utm_source');
    if (p.get('utm_campaign') !== CAMPAIGN || p.get('utm_medium') !== 'social' || !/^(facebook|instagram)$/.test(source)) return null;
    return creative(p.get('utm_content'), source, false);
  }
  function parseSelection(value) {
    var u = url(value); if (!u || u.searchParams.get('ab_placement') !== 'ig_bio_selection') return null;
    return creative(u.searchParams.get('ab_content'), 'instagram', true);
  }
  function cleanEntry(e) {
    if (!e || e.campaign !== CAMPAIGN) return null;
    var c = creative((e.qa ? 'qa_' : '') + e.creative, e.source, e.placement === 'ig_bio_selection');
    return c && c.placement === e.placement && c.content === e.content ? c : null;
  }
  function current(e, now) {
    var c = cleanEntry(e);
    return c && Number.isFinite(e.at) && e.at <= now && now - e.at <= WINDOW ? Object.assign(c,{at:e.at}) : null;
  }
  function reduce(previous, incoming, now, consent) {
    if (!consent || !Number.isFinite(now)) return null;
    var old = previous && previous.v === 1 ? previous : {};
    var first = current(old.first,now), direct = current(old.direct,now), selection = current(old.selection,now);
    var d = cleanEntry(incoming && incoming.direct), s = cleanEntry(incoming && incoming.selection);
    if (d) { direct=Object.assign(d,{at:now}); if (!first) first=Object.assign({},direct); }
    if (s) selection=Object.assign(s,{at:now});
    if (!direct && !selection) return null;
    return {v:1,first:first,direct:direct,selection:selection};
  }
  function eventParams(state, now) {
    var s=reduce(state,{},now,true); if (!s) return {};
    return {ab_campaign:CAMPAIGN,ab_direct_content:s.direct && s.direct.content || '(none)',
      ab_selected_content:s.selection && s.selection.content || '(none)',
      ab_entry_type:s.direct && s.direct.placement || 'ig_bio_selection',
      ab_qa:((s.direct && s.direct.qa)||(s.selection && s.selection.qa))?'1':'0'};
  }
  function decode(value, now) {
    if (typeof value !== 'string' || value.length > 3000) return null;
    try { return reduce(JSON.parse(value),{},now,true); } catch (_) { return null; }
  }
  function checkoutContext(checkout, stored, now) {
    var attrs = checkout && checkout.attributes || [];
    for (var a of attrs) if (a.key === '__ab_social_v1') { var c=decode(a.value,now); if (c) return c; }
    var candidates=[];
    for (var item of checkout && checkout.lineItems || [])
      for (var p of item.properties || []) if (p.key === '_ab_social_v1') { var s=decode(p.value,now); if(s) candidates.push(s); }
    candidates.sort(function(a,b){return Math.max(b.direct?b.direct.at:0,b.selection?b.selection.at:0)-Math.max(a.direct?a.direct.at:0,a.selection?a.selection.at:0);});
    // A later page view in this browser cannot prove which already-open checkout created an order.
    return candidates[0] || null;
  }
  function orderKey(value) {
    var m=/^(?:gid:\/\/shopify\/Order\/)?([0-9]{1,25})$/.exec(String(value)); return m?m[1]:null;
  }
  function sanitizeUrl(value) {
    var u=url(value); if(!u) return null;
    var path=u.pathname;
    if(path.length>240 || path.indexOf('%')!==-1) return null;
    var parts=path.split('/').filter(Boolean);
    if(parts[0] && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(parts[0])) parts.shift();
    // Shopify order-status links can contain both a shop ID and a secret token.
    if(parts.indexOf('orders')!==-1) return 'https://www.abart.com/orders';
    if(parts.indexOf('checkout')!==-1 || parts.indexOf('checkouts')!==-1) return 'https://www.abart.com/checkout';
    if(parts.indexOf('account')!==-1) return 'https://www.abart.com/account';
    if(!parts.length) return 'https://www.abart.com/';
    if(['products','collections','pages','blogs'].indexOf(parts[0])===-1 || parts.length>3 ||
      !parts.every(function(part){return /^[a-zA-Z0-9_-]+$/.test(part);})) return null;
    return 'https://www.abart.com'+path;
  }
  return {parseEntry:parseEntry,parseSelection:parseSelection,reduce:reduce,eventParams:eventParams,
    checkoutContext:checkoutContext,orderKey:orderKey,sanitizeUrl:sanitizeUrl};
});
